import { getErrorMessage } from '../../../lib/utils';

export default function (app) {
  return {
    state: {
      reportDetails: {},
    },
    getters: {

    },
    actions: {
      async getReportDetails({ commit, state, dispatch, }, submissionId) {
        commit('setError', {});
        commit('setReportDetails', {});
        const actionId = await dispatch('addPendingAction');

        try {
          const result = await app.service('reports').get(submissionId);
          commit('setReportDetails', result);

          return result;
        } catch (e) {
          commit('setError', { show: true, message: getErrorMessage(e), });
          throw e;
        } finally {
          commit('removePendingAction', actionId);
        }
      },
    },
    mutations: {
      setSubmissions: (state, submissions) => state.submissions = submissions,
      setReportDetails: (state, reportDetails) => state.reportDetails = reportDetails,
    },
  };
}
